export default class Tool {
  public id!: string;
  public name !: string;
  public type !: string;
  public level !: number;
}